import { GLOBAL_LOADER_TOGGLE } from '../../search/constants'

export default isShow => ({
  type: GLOBAL_LOADER_TOGGLE,
  isShow,
})
